export default __webpack_public_path__ + "static/media/flame.87da7028.svg";